import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-refresh-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.833 5.833A7.5 7.5 0 1 0 17.5 10.5"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M16.667 2.5v4.167H12.5"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefreshIconComponent {
  @Input() width = 18;
  @Input() height = 18;
}
